import React, { useEffect, useState } from "react";
// import { PersonalizationForm } from './personalization/PersonalizationForm';
// import { PersonalizationFormData } from '@/types/personalization';

import { PersonalizationFormData } from "../types/auth.types";
import { PersonalizationForm } from "./PersonalizationForm";
import { Heading } from "@/shared/components/typograpgy/Heading";

interface PersonalizedLearningProps {
  onComplete?: (preferences: PersonalizationFormData) => void;
}

export const PersonalizedLearning: React.FC<PersonalizedLearningProps> = ({
  onComplete,
}) => {
  const [initialData] = useState<
    PersonalizationFormData | undefined
  >();
  const [isLoading] = useState(false);

  useEffect(() => {
    const loadUserPreferences = async () => {
      // try {
      //   const user = await supabase.auth.getUser();
      //   if (user.data.user) {
      //     const preferences = await personalizationService.getUserPreferences(user.data.user.id);
      //     if (preferences) {
      //       setInitialData({
      //         fullName: preferences.full_name,
      //         stateId: preferences.state_id || '',
      //         boardId: preferences.board_id || '',
      //         classId: preferences.class_id || '',
      //         preferredLanguage: preferences.preferred_language,
      //       });
      //     }
      //   }
      // } catch (error) {
      //   console.error('Error loading preferences:', error);
      // } finally {
      //   setIsLoading(false);
      // }
    };

    loadUserPreferences();
  }, []);

  const handleSuccess = (preferences: PersonalizationFormData) => {
    onComplete?.(preferences);
  };

  return (
    <div className="w-full relative overflow-hidden">
      <div className="space-y-2 mb-10">
        <Heading>Personalize Your Learning Journey</Heading>
      </div>

      <div className="flex justify-center">
        {!isLoading && (
          <div className="w-full max-w-md">
            <PersonalizationForm
              onSuccess={handleSuccess}
              initialData={initialData}
            />
          </div>
        )}

        {isLoading && (
          <div className="w-full space-y-4">
            <div className="h-14 bg-white/10 rounded-2xl animate-pulse"></div>
            <div className="h-14 bg-white/10 rounded-2xl animate-pulse"></div>
            <div className="h-14 bg-white/10 rounded-2xl animate-pulse"></div>
            <div className="h-14 bg-white/10 rounded-2xl animate-pulse"></div>
            <div className="h-16 bg-white/10 rounded-2xl animate-pulse"></div>
          </div>
        )}
      </div>
    </div>
  );
};
